<template>
  <div class="mx-auto container">
    <PagesMarketingHeadIntro />
    <PagesMarketingWhyChooseUs />
    <PagesMarketingInteractivityMarketing />
    <PagesMarketingMetric />
  </div>
  <PartialsBenifitWidget />

</template>
<script lang="ts" setup>
import moment from "moment";
import DataLocale from "~~/config/interface/DataLocale";

const seoheader = new DataLocale([
  {
    locale: "en",
    title: "QR Codes for Boosting Your Promotion and Marketing Campaigns",
    description:
      "QR codes boost mobile social networking, payments, and marketing with new ideas. They efficiently communicate through rational use of online resources, increasing conversions and impressing potential customers.",
    keywords:
      "QR code marketing,QR code campaigns,Mobile marketing with QR codes,QR code promotions,QR code advertising,QR code branding,QR code lead generation,QR code analytics,QR code tracking,QR code strategy",
  },
  {
    locale: "de",
    title: "QR-Codes für die Förderung Ihrer Werbe- und Marketingkampagnen",
    description:
      "QR-Codes erleichtern nicht nur mobiles Social Networking und Zahlungen, sondern auch innovative Marketingstrategien. Durch die effiziente Nutzung von Online-Ressourcen ermöglichen QR-Codes schnelle und bequeme Kommunikation, was zu höheren Konversionsraten und größerer Kundenbindung führt.",
    keywords:
      "QR-Code-Marketing, QR-Code-Kampagnen, mobiles Marketing mit QR-Codes, QR-Code-Promotions, QR-Code-Werbung, QR-Code-Branding, QR-Code-Leadgenerierung, QR-Code-Analytik, QR-Code-Tracking, QR-Code-Strategie",
  },

  {
    locale: "fr",
    title: "QR Codes pour booster vos campagnes de promotion et de marketing",
    description:
      "Les QR codes facilitent non seulement les réseaux sociaux mobiles et les paiements, mais aussi la promotion avec de nouvelles idées marketing. Les QR codes permettent une communication rapide et efficace grâce à l'utilisation rationnelle des ressources en ligne, augmentant les taux de conversion et impressionnant les clients potentiels.",
    keywords:
      "marketing QR code, campagnes QR code, marketing mobile avec QR codes, promotions QR code, publicité QR code, branding QR code, génération de leads QR code, analyse QR code, suivi QR code, stratégie QR code",
  },

  {
    locale: "it",
    title: "QR Code per potenziare le tue campagne di promozione e marketing",
    description:
      "I codici QR non solo facilitano il networking e i pagamenti mobili, ma anche la promozione con nuove idee di marketing. I codici QR consentono una comunicazione veloce ed efficiente grazie all'uso razionale delle risorse online, aumentando i tassi di conversione e impressionando i potenziali clienti.",
    keywords:
      "marketing QR code, campagne QR code, marketing mobile con QR code, promozioni QR code, pubblicità QR code, branding QR code, generazione di lead QR code, analisi QR code, tracciamento QR code, strategia QR code",
  },
  {
    locale: "ja",
    title: "QRコードを活用して販売促進とマーケティングを強化しよう",
    description:
      "QRコードは、モバイルソーシャルネットワーキング、決済、マーケティングを新しいアイデアで促進します。オンラインリソースを合理的に活用して効率的にコミュニケーションを行い、コンバージョン率を高め、潜在顧客に深い印象を与えます。",
    keywords:
      "QRコードマーケティング、QRコードキャンペーン、QRコードを活用したモバイルマーケティング、QRコードプロモーション、QRコード広告、QRコードブランディング、QRコードリードジェネレーション、QRコード解析、QRコードトラッキング、QRコード戦略",
  },
  {
    locale: "es",
    title: "Códigos QR para impulsar sus campañas de promoción y marketing",
    description:
      "Los códigos QR impulsan la promoción, los pagos y el marketing móvil con nuevas ideas. Comunican eficientemente a través del uso racional de recursos en línea, aumentando las conversiones e impresionando a los clientes potenciales.",
    keywords:
      "Marketing con códigos QR, campañas con códigos QR, marketing móvil con códigos QR, promociones con códigos QR, publicidad con códigos QR, branding con códigos QR, generación de leads con códigos QR, análisis de códigos QR, seguimiento de códigos QR, estrategia de códigos QR",
  },
  {
    locale: "nl",
    title:
      "QR-codes voor het stimuleren van uw promotie- en marketingcampagnes",
    description:
      "QR-codes stimuleren mobiel sociaal netwerken, betalingen en marketing met nieuwe ideeën. Ze communiceren efficiënt door rationeel gebruik van online resources, waardoor conversies worden verhoogd en potentiële klanten worden geïmponeerd.",
    keywords:
      "QR-code marketing, QR-code campagnes, mobiele marketing met QR-codes, promoties met QR-codes, advertenties met QR-codes, branding met QR-codes, leadgeneratie met QR-codes, QR-code analyse, QR-code tracking, QR-code strategie",
  },
  {
    locale: "vi",
    title:
      "Sử dụng mã QR để tăng cường chiến dịch quảng cáo và tiếp thị của bạn",
    description:
      "Mã QR thúc đẩy mạng xã hội di động, thanh toán và tiếp thị với những ý tưởng mới. Chúng hiệu quả trong việc truyền đạt thông điệp thông qua sử dụng hợp lý các tài nguyên trực tuyến, tăng tỷ lệ chuyển đổi và ấn tượng khách hàng tiềm năng.",
    keywords:
      "Tiếp thị với mã QR, Chiến dịch với mã QR, Tiếp thị di động với mã QR, Khuyến mãi với mã QR, Quảng cáo với mã QR, Thương hiệu với mã QR, Tạo khách hàng tiềm năng với mã QR, Phân tích mã QR, Theo dõi mã QR, Chiến lược với mã QR",
  },
  {
    locale: "zh",
    title: "使用QR码增强您的推广和营销活动",
    description:
      "QR码推广移动社交网络、支付和营销，带来新思路。它们通过合理利用在线资源有效地传递信息，提高转化率并给潜在客户留下深刻印象。",
    keywords:
      "QR码营销，QR码活动，使用QR码的移动营销，QR码促销，QR码广告，QR码品牌营销，QR码引流，QR码分析，QR码跟踪，QR码策略",
  },
  {
    locale: "pt",
    title:
      "Utilize códigos QR para impulsionar suas campanhas de promoção e marketing",
    description:
      "Códigos QR impulsionam redes sociais móveis, pagamentos e marketing com novas ideias. Eles comunicam de forma eficiente através do uso racional dos recursos online, aumentando conversões e impressionando potenciais clientes.",
    keywords:
      "Marketing com códigos QR, Campanhas com códigos QR, Marketing móvel com códigos QR, Promoções com códigos QR, Publicidade com códigos QR, Branding com códigos QR, Geração de leads com códigos QR, Análise de códigos QR, Rastreamento de códigos QR, Estratégia com códigos QR",
  },
]);

const datajd = useDataJd();
const meta = useMeta();

const i18nHead = useLocaleHead({
  addSeoAttributes: {
    canonicalQueries: ["/"],
  },
});
const meta_tags = meta.metaTag({
  title: seoheader.data.title,
  description: seoheader.data.description,
  url: datajd.currentURL(),
  image: datajd.assets("/images/og/marketing.png"),
});
useHead({
  title: seoheader.data.title,
  meta: [
    { name: "description", content: seoheader.data.description },
    { name: "keywords", content: seoheader.data.keywords },
    ...(i18nHead.value.meta || []),
    ...meta_tags,
  ],
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs!.lang,
  },
  link: [...(i18nHead.value.link || [])],
});
useSchemaOrg([
  defineWebPage({
    name: seoheader.data.title,
    datePublished: moment("2023-05-03").toISOString(),
    dateModified: moment().toISOString(),
    description: seoheader.data.description,
    inLanguage: datajd.inLanguages(true),
    url: datajd.currentURL(),
    image: datajd.assets("/images/og/marketing.png"),
  }),
  defineBreadcrumb({
    itemListElement: [
      {
        item: {
          "@id": datajd.currentHost(),
          name: "Home",
        },
      },
      {
        item: {
          name: "QR Codes in Marketing",
          "@id": datajd.currentHost() + useRoute().fullPath,
        },
      },
    ],
  }),
]);
</script>
